'use strict';

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// Import utilities.
import '@utilities/in-view';

// Import Singletons
import '@utilities/detect-touch';
import 'lazysizes';

let lastScrollPosition = 0;
let activeSlider = 0;
let activeSlide = 0;
// let isDown = false;
// let startX = [];
// let scrollLeft = [];
// let currentlyDragged = [];
let numSliders = 0;
let moreInfoActive = false;

let minPadding = 100000;

function adjustPadding() {
    var sliders = document.querySelectorAll('[js-hook-projectslider]');

    sliders.forEach(function(slider) {
        var paddingLeft = calculateDesiredPadding(slider, true)-15;
        var paddingRight = calculateDesiredPadding(slider, false)-30;

        if(window.innerWidth < 768){
            paddingLeft = calculateDesiredPadding(slider, true)-5;
            paddingRight = calculateDesiredPadding(slider, false)-10;
        }

        if(window.innerWidth > 768){
            let tt = slider.parentElement.querySelector('.project-title');
            tt.style.left = (paddingLeft - tt.offsetWidth - 2)+"px";
        }

        slider.style.setProperty('--slider-padding-left', `${paddingLeft}px`);
        slider.style.setProperty('--slider-padding-right', `${paddingRight}px`);

        if(paddingLeft < minPadding){
            minPadding = paddingLeft;
        }
    });
}

function initSliders(){

    document.querySelector('[js-hook-nav-left]').addEventListener('click', function() {
        prevSlide();
    });

    document.querySelector('[js-hook-nav-right]').addEventListener('click', function() {
        nextSlide();
    });


    document.querySelectorAll('[js-hook-phtd-more]').forEach(function(linkmore){
        linkmore.addEventListener('click', function() {
            console.log("TEST");
            let did = this.dataset.id;
            let d = document.querySelector(`.phc-${did}`);
            let cb = document.querySelector(`[js-hook-phtd-close-${did}]`);
            cb.innerHTML = "CLOSE";

            d.classList.add('shown');
            document.querySelector('.project-highlight').classList.add('blurMeDaddy');
            moreInfoActive = true;
        });
    });

    document.querySelectorAll('[js-hook-phtd-close]').forEach(function(linkless){
        linkless.addEventListener('click', function() {
            let did = this.dataset.id;
            let d = document.querySelector(`.phc-${did}`);
            if(d.classList.contains('shown')){
                let cb = document.querySelector(`[js-hook-phtd-close-${did}]`);
                cb.innerHTML = "BACK";
                d.classList.remove('shown');
                document.querySelector('.project-highlight').classList.remove('blurMeDaddy');
                moreInfoActive = false;
            } else {
                unactiveateSlide();
            }

        });
    });



    // document.querySelector('[js-hook-project-text-mobile]').classList.toggle('shown');
    // if(document.querySelector('[js-hook-project-text-mobile]').classList.contains('shown')){
    //     document.querySelector('[js-hook-more-info-mobile-toggle]').innerHTML = "LESS INFO";
    //     document.querySelector('[js-hook-navigation]').classList.remove('active');
    //     document.querySelector('[js-hook-main-image]').classList.add('blurMeDaddy');
    // } else {
    //     document.querySelector('[js-hook-more-info-mobile-toggle]').innerHTML = "MORE INFO";
    //     document.querySelector('[js-hook-navigation]').classList.add('active');
    //     document.querySelector('[js-hook-main-image]').classList.remove('blurMeDaddy');
    // }


    var sliderContainers = document.querySelectorAll('[js-hook-projectslider-main]');

    sliderContainers.forEach(function(sliderContainer) {


        // startX[sliderContainer.dataset.id] = 0;
        // scrollLeft[sliderContainer.dataset.id] = 0;
        // currentlyDragged[sliderContainer.dataset.id] = false;


        // // sliderContainer.addEventListener('mousedown', (e) => {
        // //     isDown = true;
        // //     currentlyDragged[sliderContainer.dataset.id] = false;
        // //     startX[sliderContainer.dataset.id] = e.pageX - sliderContainer.offsetLeft;
        // //     scrollLeft[sliderContainer.dataset.id] = sliderContainer.scrollLeft;

        // // });
        // // sliderContainer.addEventListener('mouseleave', (e) => {
        // //     isDown = false;
        // //     if(currentlyDragged[sliderContainer.dataset.id]){
        // //         e.preventDefault();
        // //     }
        // // });
        // // sliderContainer.addEventListener('mouseup', (e) => {
        // //     isDown = false;
        // //     if(currentlyDragged[sliderContainer.dataset.id]){
        // //         e.preventDefault();
        // //     }
        // // });
        // // sliderContainer.addEventListener('mousemove', (e) => {
        // //     if(!isDown) return;
        // //     currentlyDragged[sliderContainer.dataset.id] = true;
        // //     e.preventDefault();
        // //     const x = e.pageX - sliderContainer.offsetLeft;
        // //     const walk = (x - startX[sliderContainer.dataset.id]) * 1;
        // //     sliderContainer.scrollLeft = scrollLeft[sliderContainer.dataset.id] - walk;
        // // });

        if(window.innerWidth >= 768){
            sliderContainer.addEventListener('scroll', (e) => {
                let t = e.target;
                let tt = t.querySelector('.project-title');
                let ttWidth = tt.offsetWidth;
                let targetscroll =  parseInt(window.innerWidth) - parseInt(t.querySelector('.ps-1').dataset.iw) - ttWidth;

                if(t.scrollLeft - targetscroll+25 > 0){
                    tt.style.marginLeft = (t.scrollLeft - targetscroll+25)+"px";
                } else {
                    tt.style.marginLeft = "-2px";
                }
            });
        }

    });


    var sliders = document.querySelectorAll('[js-hook-projectslider]');
	numSliders = sliders.length;

    sliders.forEach(function(slider) {
        var items = slider.querySelectorAll('.project-slide');

        items.forEach(function(item) {
            item.addEventListener('click', function() {

                let ss = false;
                if(item.dataset.sliderid != activeSlider){
                    ss = true;
                }
                activeSlider = item.dataset.sliderid;
                activeSlide = item.dataset.id;

                switchSlides(activeSlider, activeSlide, ss);

            });

        });
    });
}


function switchSlides(sliderId, slideId, sliderChange = false){

    let sl = document.querySelector(`#project-slider-${sliderId}`);
    let item = sl.querySelector(`.ps-${slideId}`);
    var imgSrc = item.querySelector('img').src;

    document.querySelectorAll('.project-title-mobile').forEach(function(element) {
        element.classList.add('hidden');
    });

    document.querySelectorAll('.project-highlight-text').forEach(function(element) {
        element.classList.remove('active');
    });

    document.querySelectorAll('.phc-inner-container').forEach(function(element) {
        element.classList.remove('active');
        // element.classList.remove('shown');
    });

    // document.querySelector('.project-highlight').classList.remove('blurMeDaddy');

    document.querySelector('.phc-'+sliderId).classList.add('active');
    document.querySelector('.phlt-'+sliderId).classList.add('active');

    let highlightStyle = item.dataset.fullheight;
    var targetDiv = document.querySelector('[js-hook-main-image]');
    targetDiv.classList.remove('regular', 'full', 'cover');
    targetDiv.classList.add('active');
    targetDiv.classList.add(highlightStyle);

    var targetDivText = document.querySelector('[js-hook-project-text]');
    targetDivText.classList.add('active');

    var hlnavigation = document.querySelector('[js-hook-navigation]');
    hlnavigation.classList.add('active');

    targetDiv.style.backgroundImage = `url(${imgSrc})`;
    document.querySelector('[js-hook-overview]').classList.add('highlight-active');
    navbar.classList.remove('hide');
    // document.querySelector('.nav-mobile').classList.add('highlight-active');

    // change backgourn color of body:
    document.querySelector("body").style.backgroundColor = sl.dataset.bg;
    document.querySelector("body").style.transition = "background-color 300ms linear";
    document.ATTRIBUTE_NODE

    let t = document.querySelector(`#project-slider-${activeSlider}`).dataset.title;
    window.location.hash = `#${t}`;

    // document.querySelector('.project-slide.active').classList.remove('active');

    // item.classList.add('active');

    if(sliderChange){
        let sp = 0;
        if(window.innerWidth < 768){
            sp = 20 + ((sl.dataset.id-1)*200) - (window.innerHeight/2) + 100;
        } else {
            sp = 150 + ((sl.dataset.id-1)*540) - (window.innerHeight/2) + 270;
        }
        // scrollTo(document, sp, 3000);
        document.querySelector('body').scrollTo({
            top: sp,
            behavior: 'smooth',
            duration: 350
        });


        if(moreInfoActive){
            document.querySelectorAll('.phc-inner-container').forEach(function(element) {
                element.classList.remove('shown');
            });

            document.querySelector(`.phc-${sliderId}`).classList.add('shown');
        }

    }

}

function unactiveateSlide(){
    var targetDiv = document.querySelector('[js-hook-main-image]');
    targetDiv.classList.remove('active');

    document.querySelectorAll('.project-highlight-title-mobile').forEach(function(element) {
        element.classList.remove('active');
    });

    document.querySelectorAll('.phc-inner-container').forEach(function(element) {
        element.classList.remove('shown');
    });

    document.querySelectorAll('.project-title-mobile').forEach(function(element) {
        element.classList.remove('hidden');
    });

    document.querySelector('.project-highlight').classList.remove('blurMeDaddy');
    moreInfoActive = false;

    removeHash();

    var targetDivText = document.querySelector('[js-hook-project-text]');
    targetDivText.classList.remove('active');

    document.querySelector('[js-hook-overview]').classList.remove('highlight-active');
    // document.querySelector('.nav-mobile').classList.remove('highlight-active');
    document.querySelector('[js-hook-navigation]').classList.remove('active');

    document.querySelector("body").style.backgroundColor = "#F1F1F1";

    activeSlider = 0;
    activeSlide = 0;

}

function removeHash () {
    history.pushState("", document.title, window.location.pathname
                                                       + window.location.search);
}


function setInitialRandomScroll(){

    var outersliders = document.querySelectorAll('[js-hook-projectslider-main]');
    let i = 0;
    outersliders.forEach(function(slider) {
        var viewportWidth = window.innerWidth;


        let pp = parseInt(getComputedStyle(slider.children[1]).getPropertyValue('--slider-padding-left'));

        let scrollToStart = 0;
        if(viewportWidth < 768){

            if(pp > minPadding){
                scrollToStart = viewportWidth/2;
            }

            // randomValue = Math.floor(Math.random() * 40);
            // randomOffset = 20;
            // if(i < outersliders.length/2){
            //     randomScrollPosition = viewportWidth * 0.2 - i*50;
            // } else {
            //     randomScrollPosition = viewportWidth * 0.2 - (i-outersliders.length/2)*50;
            // }
			scrollToStart = viewportWidth/2 - 50;

        } else {
            // scrollToStart =  window.innerWidth-pp;
            scrollToStart = (pp-15)-((i+5)*100);
            // randomScrollPosition = 10;
            // if(i < outersliders.length/2){
            //     randomScrollPosition = viewportWidth * 0.5 - i*100;
            // } else {
            //     randomScrollPosition = viewportWidth * 0.5 - (i-outersliders.length/2)*100;
            // }
        }





        slider.scrollLeft = 0;//randomScrollPosition-randomOffset;
        slider.classList.remove('awakening');

        setTimeout(function(){
            // scrollTo(randomScrollPosition+randomValue, 3000);
            slider.scrollTo({
                left: scrollToStart,
                behavior: 'smooth',
            });
        }, 250);
        i++;
    });
}

function calculateDesiredPadding(slider, isLeft) {
    var viewportWidth = window.innerWidth;
    var elementWidth;
    if(viewportWidth < 768){
		return viewportWidth-50;
        // elementWidth = isLeft ? slider.children[0].dataset.miw : slider.children[slider.children.length - 1].dataset.miw;
    } else {
        elementWidth = isLeft ? slider.children[0].dataset.iw : slider.children[slider.children.length - 1].dataset.iw;
    }
    var padding = viewportWidth - (elementWidth);
    return padding > 0 ? padding : 0;
}


document.addEventListener('DOMContentLoaded', function(){
    adjustPadding();
    initSliders();
    setInitialRandomScroll();

    //More stuff:
    document.querySelector('[js-hook-logo]').addEventListener('click', function() {
        if(!document.querySelector('.work-overview').classList.contains('highlight-active') && !document.querySelector('.work-overview').classList.contains('overlay-active')){
            location.reload(true);
        } else {
            unactiveateSlide();
            document.querySelector('.work-overview').classList.remove('overlay-active');
            document.querySelector('.work-overview').classList.remove('blurmeDaddy');
            if(document.querySelector('.poActive') != null) document.querySelector('.poActive').classList.remove('poActive');

            document.querySelectorAll('[js-hook-nav]').forEach(function(element) {
                let id = element.dataset.id;
                if(id == 1){
                    element.classList.add('activeNav');
                } else {
                    element.classList.remove('activeNav');
                }
            });

            if(document.querySelector('.mobile-overlay-menu').classList.contains('active')){
                if(document.querySelector('.phc-inner-container.hideme') != null){
                    document.querySelector('.phc-inner-container.hideme').classList.remove('hideme');
                }
                document.querySelector('[js-hook-main-image]').classList.remove('blurMeDaddy');
                document.querySelector('.work-overview').classList.remove('blurMeDaddy');
                document.querySelectorAll('.page-overlay').forEach(function(element) {
                    element.classList.remove('blurMeDaddy');
                });
                document.querySelector('.mobile-overlay-menu').classList.remove('active');
            }
        }
    });

    document.querySelector('[js-hook-open-nav]').addEventListener('click', function() {

        document.querySelector('.mobile-overlay-menu').classList.toggle('active');

        document.querySelectorAll('.phc-inner-container').forEach(function(element) {
            element.classList.remove('shown');
        });
        moreInfoActive = false;

        if(document.querySelector('.mobile-overlay-menu').classList.contains('active')){
            if(document.querySelector('.phc-inner-container.active') != null){
                document.querySelector('.phc-inner-container.active').classList.add('hideme');
            }
            document.querySelector('[js-hook-main-image]').classList.add('blurMeDaddy');
            document.querySelector('.work-overview').classList.add('blurMeDaddy');
            document.querySelectorAll('.page-overlay').forEach(function(element) {
                element.classList.add('blurMeDaddy');
            });
            document.querySelector('[js-hook-open-nav]').classList.add('active');

        } else {
            if(document.querySelector('.phc-inner-container.hideme') != null){
                document.querySelector('.phc-inner-container.hideme').classList.remove('hideme');
            }
            document.querySelector('[js-hook-main-image]').classList.remove('blurMeDaddy');
            document.querySelector('.work-overview').classList.remove('blurMeDaddy');
            document.querySelectorAll('.page-overlay').forEach(function(element) {
                element.classList.remove('blurMeDaddy');
            });
            document.querySelector('[js-hook-open-nav]').classList.remove('active');
        }
    });

    if(window.location.hash){
        let t = window.location.hash.replace("#", "");
        if(t == "info"){
            document.querySelector('.work-overview').classList.add('overlay-active');
            let p = document.querySelector('.poActive');
            if(p != null) p.classList.remove('poActive');
            document.querySelector('.po-2').classList.add('poActive');
        } else if(t == "contact"){
            document.querySelector('.work-overview').classList.add('overlay-active');
            let p = document.querySelector('.poActive');
            if(p != null) p.classList.remove('poActive');
            document.querySelector('.po-3').classList.add('poActive');
        } else {
            let slider = document.querySelector(`[data-title="${t}"]`);
            if(slider != null){
                activeSlider = slider.dataset.id;
                activeSlide = 1;
                switchSlides(activeSlider, activeSlide, true);
            }
        }
    }
});

let resizeTimeout;
window.addEventListener('resize', () => {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(() => {
		window.location.reload();
	}, 500);
});

// function for detecting scroll on body
const navbar = document.querySelector('header');
const threshold = 160;
const workOverview = document.querySelector('.work-overview');
let ticking = false;

document.body.addEventListener("scroll", function () {
    if (!ticking) {
        requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
        });
        ticking = true;
    }
}, false);

function handleScroll() {
    const outersliders = document.querySelectorAll('[js-hook-projectslider-main]');
    const currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

    const activeMoment =
    workOverview &&
    (
        workOverview.classList.contains('highlight-active') ||
        workOverview.classList.contains('overlay-active') ||
        workOverview.classList.contains('blurMeDaddy')
    );

    if (!activeMoment) {
        if (currentScrollPosition >= threshold) {
            document.body.classList.add('disable-bounce');
        } else {
            document.body.classList.remove('disable-bounce');
        }

        if (currentScrollPosition > threshold) {
            if (currentScrollPosition > lastScrollPosition) {
                navbar.classList.add('hide');
            } else {
                navbar.classList.remove('hide');
            }
        } else {
            navbar.classList.remove('hide');
        }
    }

    lastScrollPosition = currentScrollPosition;

    outersliders.forEach(function (slider) {
        const ss = slider.querySelector('.project-slider-container');
        const s = ss.dataset.slidespeed;
        const up = currentScrollPosition < lastScrollPosition;

        if (window.innerWidth > 768) {
            slider.scrollBy(up ? -s : +s, 0);
        }
    });
}


function nextSlide(){
    if(activeSlider === 0) return;
    let curSlider = document.querySelector(`#project-slider-${activeSlider}`);
    let max = curSlider.dataset.numslides;
    if(activeSlide < max){
        activeSlide++;
        curSlider.scrollBy({
            top: 0,
            left: 200,
            behavior : "smooth"
        });
        switchSlides(activeSlider, activeSlide);
    } else {
		if(activeSlider < numSliders){
            nextSlider();
		} else {
			document.querySelector('body').scrollTo({
				top: 0,
				behavior: 'smooth'
			});
			activeSlider = 1;
			activeSlide = 1;
			switchSlides(activeSlider, activeSlide);
		}
    }
}

function prevSlide(){
    if(activeSlider === 0) return;
    let curSlider = document.querySelector(`#project-slider-${activeSlider}`);
    if(activeSlide > 1){
        activeSlide--;
        curSlider.scrollBy({
            top: 0,
            left: -200,
            behavior : "smooth"
        })
        switchSlides(activeSlider, activeSlide);
    } else if(activeSlide === 1){
        prevSlider(true);
    }
}

function nextSlider(){
    if(activeSlider === 0) return;
    if(activeSlider >= numSliders) return;
    activeSlider++;
    activeSlide = 1;
    switchSlides(activeSlider, activeSlide, true);
}

function prevSlider(end){
    if(activeSlider === 0) return;
    if(activeSlider > 1){
        activeSlider--;
        // let t = document.querySelector(`#project-slider-${activeSlider}`).dataset.title;
		if(end){
			activeSlide = parseInt(document.querySelector(`#project-slider-${activeSlider}`).dataset.numslides);
		} else {
			activeSlide = 1;
		}
        switchSlides(activeSlider, activeSlide, true);
    }
}

document.addEventListener('keydown', function(event) {
    // right arrow
    if (event.key === "ArrowRight" || event.keyCode === 39) {
        event.preventDefault();
        nextSlide();
    }
    // left arrow
    if (event.key === "ArrowLeft" || event.keyCode === 37) {
        event.preventDefault();
        prevSlide();
    }
    // down arrow
    if (event.key === "ArrowDown" || event.keyCode === 40) {
        event.preventDefault();
        nextSlider();
    }
    // up arrow
    if (event.key === "ArrowUp" || event.keyCode === 38) {
        event.preventDefault();
        prevSlider();
    }

    // escape key
    if (event.key === "Escape" || event.keyCode === 27) {
        event.preventDefault();

        unactiveateSlide();
        document.querySelector('.work-overview').classList.remove('overlay-active');
        document.querySelector('.work-overview').classList.remove('blurmeDaddy');
        if(document.querySelector('.poActive') != null) document.querySelector('.poActive').classList.remove('poActive');

        document.querySelectorAll('[js-hook-nav]').forEach(function(element) {
            let id = element.dataset.id;
            if(id == 1){
                element.classList.add('activeNav');
            } else {
                element.classList.remove('activeNav');
            }
        });

        if(document.querySelector('.mobile-overlay-menu').classList.contains('active')){
            if(document.querySelector('.phc-inner-container.hideme') != null){
                document.querySelector('.phc-inner-container.hideme').classList.remove('hideme');
            }
            document.querySelector('[js-hook-main-image]').classList.remove('blurMeDaddy');
            document.querySelector('.work-overview').classList.remove('blurMeDaddy');
            document.querySelectorAll('.page-overlay').forEach(function(element) {
                element.classList.remove('blurMeDaddy');
            });
            document.querySelector('.mobile-overlay-menu').classList.remove('active');
        }

    }





});

document.querySelectorAll('[js-hook-nav]').forEach(function(element) {

    element.addEventListener('click', function() {
        let id = element.dataset.id;

        document.querySelector('.activeNav').classList.remove('activeNav');
        element.classList.add('activeNav');

        document.querySelector('.work-overview').classList.remove('blurMeDaddy');
        document.querySelector('.mobile-overlay-menu').classList.remove('active');
        document.querySelector('[js-hook-main-image]').classList.remove('blurMeDaddy');

        document.querySelectorAll('.page-overlay').forEach(function(element) {
            element.classList.remove('blurMeDaddy');
        });

        if(id == 1){
            unactiveateSlide();
            document.querySelector('.work-overview').classList.remove('overlay-active');
            document.querySelector('.poActive').classList.remove('poActive');
        }

        if(id > 1){
            unactiveateSlide();
            document.querySelector('.work-overview').classList.add('overlay-active');
            let p = document.querySelector('.poActive');
            if(p != null) p.classList.remove('poActive');
            document.querySelector('.po-'+id).classList.add('poActive');
            if(id == 2){
                window.location.hash = 'info';
            } else if(id == 3){
                window.location.hash = 'contact';
            }
        }

    });
});


document.querySelectorAll('[js-hook-closeslider]').forEach(function(element) {
    element.addEventListener('click', function() {
        unactiveateSlide();
    });
});


// window.addEventListener('popstate', function() {
//     // Reload the page when the user presses the back button
//     location.reload();
// });





let touchstartX = 0
let touchendX = 0

function checkDirection() {
  if (touchendX < touchstartX){
    nextSlide();
  }
  if (touchendX > touchstartX){
    prevSlide();

  }
}

document.addEventListener('touchstart', e => {
    if(document.querySelector('.work-overview').classList.contains('highlight-active')){
        touchstartX = e.changedTouches[0].screenX
    }
})

document.addEventListener('touchend', e => {
    if(document.querySelector('.work-overview').classList.contains('highlight-active')){
        touchendX = e.changedTouches[0].screenX
        checkDirection()
    }
})



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/EXT/Forever/frontend/source/javascript/main.js